















import { useStampStore } from '@/store/stamp';
import { computed, defineComponent } from '@vue/composition-api';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'NgoStampGoal',
  setup() {
    const stampStore = useStampStore(); // store
    const { globalActInfo } = storeToRefs(stampStore);
    const globalActInfoVal = computed(() => globalActInfo.value); // 总活动信息

    // 捐贈进度
    // eslint-disable-next-line max-len
    const percent = computed(() => ((globalActInfoVal.value.totalSendNum / globalActInfoVal.value.totalLimit) * 100).toFixed(2));

    return {
      globalActInfoVal,
      percent,
    };
  },
  components: {},
});
